import { useNavigate } from "@tanstack/react-router";
import type { DownloadsBar } from "@/lib/skills/analytics";

export function DownloadsBySkillChart({ bars }: { bars: DownloadsBar[] }) {
  const navigate = useNavigate();
  // Guarantee a positive denominator: a 0 here (empty/all-zero catalog) would make
  // every bar height NaN. Math.max keeps it >= 1 without the ||-falsy lint concern.
  const max = Math.max(bars[0]?.downloads ?? 0, 1);

  return (
    <div className="rounded-[12px] border border-border-1 bg-bg-1 p-6 shadow-xs">
      <div className="mb-6 flex items-center justify-between">
        <h3 className="font-display text-[17px] font-semibold text-navy">Downloads by skill</h3>
        <span className="text-xs text-fg-3">Top 6 · all time</span>
      </div>
      {bars.length === 0 ? (
        <p className="text-sm text-fg-3">No published skills yet.</p>
      ) : (
        <div className="flex h-52 items-end justify-between gap-3">
          {bars.map((bar) => (
            <button
              key={bar.slug}
              type="button"
              onClick={() => void navigate({ to: "/skill/$id", params: { id: bar.slug } })}
              className="group flex h-full flex-1 cursor-pointer flex-col items-center justify-end gap-2"
              title={`${bar.title} — ${bar.downloads} downloads`}
            >
              <span className="text-xs font-semibold text-fg-2">{bar.downloads}</span>
              <div
                className="w-full rounded-t-[6px] transition-[height] duration-300 ease-out group-hover:opacity-90"
                style={{
                  height: `${Math.max((bar.downloads / max) * 100, 4)}%`,
                  backgroundImage: "var(--nymbl-gradient)",
                }}
              />
              <span className="line-clamp-1 text-center text-[11px] text-fg-3">
                {bar.title.split(" ").slice(0, 2).join(" ")}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
